// import QuestData from '../../controllers/quest/helper/getQuestData';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { logRecevied } from '../../socket/helpers/loger';
var freespin = false;

export default function serverMSG(msg, func) {
	switch (msg.service) {
		case 'auth':
			GameConfigs.auth = msg.data;
			func(msg.data.balance.currency);
			logRecevied(msg);
			break;
		case 'settings':
			GameConfigs.settings =
				Object.keys(msg.data).length > 0 ? msg.data : GameConfigs.settings;
			if (
				GameConfigs.config.bet_steps[+msg.data.current_bet] !==
				GameConfigs.currentBet
			) {
				if (msg.data.current_bet) {
					GameConfigs.currentBet =
						GameConfigs.config.bet_steps[msg.data.current_bet];
				} else {
					GameConfigs.currentBet = GameConfigs.config.bet_steps[0];
				}
			}
			break;
		case 'bet':
			clearTimeout(GameConfigs.reelTimeout);
			HELPERS.setCurrentMessage(msg.data);
			logRecevied(msg);
			HELPERS.printReels(msg.data.reels);
			GameConfigs.auth.balance.amount = msg.data.balance;
			GameConfigs.reelComponent.stop(msg.data, GameConfigs.settings.fast_spin);
			if (msg.data.bonuswin) {
				GameConfigs.bonusRoundInfo = msg.data.bonuswin;
				if (!GameConfigs.bonusBuy) {
					HELPERS.dispatchCustomEvent(EVENTS.BONUS_BUY, { bonus: true });
					GameConfigs.bonusBuy = true;
				}
			}
			break;
		case 'bonusrestore':
			//set current bonus round msg
			let currentBonusMsg = msg.data.bonusround
				? msg.data.bonusround
				: msg.data.spinresult;
			GameConfigs.bonusRoundInfo = msg.data.spinresult.bonuswin;
			GameConfigs.bonusRoundData = currentBonusMsg;
			HELPERS.setCurrentMessage(currentBonusMsg);
			HELPERS.setBonusRestoreMsg(msg.data);
			HELPERS.printReels(currentBonusMsg.reels);
			GameConfigs.bonusBuy = true;
			HELPERS.dispatchCustomEvent(EVENTS.BONUS_BUY, { bonus: true });
			logRecevied(msg);
			break;
		// case 'quest':
		// 	GameConfigs.quest = { ...GameConfigs.quest, ...msg.data };
		// 	GameConfigs.quest_parsed = QuestData.processQuest(msg.data);
		// 	const time = parseInt(msg.data.seconds_left, 10);
		// 	if (!GameConfigs.hasQuest) {
		// 		func.updateTimer(time);
		// 		HELPERS.dispatchCustomEvent(EVENTS.HAS_QUEST, {
		// 			hasQuest: true
		// 		});
		// 	}
		// 	if (GameConfigs.updateQuest) {
		// 		func.updateTimer(time);
		// 		GameConfigs.updateQuest = false;
		// 	}
		// 	if (GameConfigs.quest_claim.activated_item > 0) {
		// 		let quest_current = GameConfigs.quest_parsed.items.find(
		// 			(item) => item.item.id === GameConfigs.quest_claim.activated_item
		// 		);
		// 		GameConfigs.quest_current = quest_current;
		// 	}
		// 	logRecevied(msg);
		// 	break;
		case 'bonusstep':
			clearTimeout(GameConfigs.reelTimeout);
			HELPERS.setCurrentMessage(msg.data);
			HELPERS.printReels(msg.data.reels);
			logRecevied(msg);
			GameConfigs.reelComponent.stop(msg.data, GameConfigs.settings.fast_spin);
			break;
		case 'freespinstep':
			HELPERS.setCurrentMessage(msg.data);
			HELPERS.printReels(msg.data.reels);
			logRecevied(msg);
			GameConfigs.reelComponent.stop(msg.data, GameConfigs.settings.fast_spin);
			let obj = {
				...GameConfigs.freeSpinLocal,
				status: msg.data.free_spin_step.status,
				totalWin: msg.data.free_spin_step.total_win,
				count: msg.data.free_spin_step.count,
				started: true
			};
			HELPERS.dispatchCustomEvent(EVENTS.FREESPIN, {
				freespin: obj
			});
			GameConfigs.freeSpinLocal = obj;
			if (msg.data.bonuswin) {
				GameConfigs.bonusRoundInfo = msg.data.bonuswin;
				if (!GameConfigs.bonusBuy) {
					HELPERS.dispatchCustomEvent(EVENTS.BONUS_BUY, { bonus: true });
					GameConfigs.bonusBuy = true;
					HELPERS.dispatchCustomEvent(EVENTS.FREESPIN, {
						freespin: { ...GameConfigs.freeSpinLocal, hasBonus: true }
					});
					GameConfigs.freeSpinLocal = {
						...GameConfigs.freeSpinLocal,
						hasBonus: true
					};
				}
			}
			break;
		case 'freespins':
			if (!freespin) {
				freespin = true;
				GameConfigs.freeSpin = msg.data;
				GameConfigs.isFreeSpin = true;
				let obj = {
					bet_steps: msg.data.bet_level,
					count: msg.data.count,
					status: 'active',
					isFinished: false,
					show: true,
					started: msg.data.bonus_restore ? true : false,
					totalWin: msg.data.total_win_str,
					hasBonus: msg.data.bonus_restore ? true : false
				};
				HELPERS.dispatchCustomEvent(EVENTS.FREESPIN, {
					freespin: obj
				});
				GameConfigs.freeSpinLocal = obj;
				let disabled = {
					...GameConfigs.disabled,
					auto: true
				};
				HELPERS.dispatchCustomEvent(EVENTS.IS_DISABLED, { disable: disabled });
				GameConfigs.disabled = disabled;
				GameConfigs.currentBet =
					GameConfigs.config.bet_steps[msg.data.bet_level];
				HELPERS.dispatchCustomEvent(EVENTS.BET_UPDATE, {
					betAmount: GameConfigs.config.bet_steps[msg.data.bet_level]
				});
			} else {
				let obj = {
					bet_steps: msg.data.bet_level,
					count: msg.data.count,
					status: 'active',
					isFinished: false,
					show: false,
					started: true,
					totalWin: msg.data.total_win_str,
					hasBonus: msg.data.bonus_restore ? false : true
				};
				HELPERS.dispatchCustomEvent(EVENTS.FREESPIN, {
					freespin: obj
				});
				GameConfigs.freeSpinLocal = obj;
			}
			if (msg.data.bonus_restore) {
				let currentBonusMsg = msg.data.bonus_restore.bonusround
					? msg.data.bonus_restore.bonusround
					: msg.data.bonus_restore.spinresult;
				GameConfigs.bonusRoundInfo = msg.data.bonus_restore.spinresult.bonuswin;
				HELPERS.setCurrentMessage(currentBonusMsg);
				HELPERS.setBonusRestoreMsg(msg.data.bonus_restore);
				GameConfigs.bonusBuy = true;
				HELPERS.dispatchCustomEvent(EVENTS.BONUS_BUY, { bonus: true });
			}
			logRecevied(msg);
			break;
		default:
			break;
	}
}
